import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDeviceProfile } from '@/api/routes/device-profiles/types';
import smartSort from '@/utils/smartSort';

import { fetchDeviceProfiles } from './actionCreators';

interface InitialState {
  deviceProfiles: IDeviceProfile [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  deviceProfiles: [],
  isLoading: false,
  error: '',
};

export const deviceProfilesSlice = createSlice({
  name: 'deviceProfiles',
  initialState,
  reducers: {
    removeDeviceProfile: (state, action: PayloadAction<string>) => {
      const deletedId = action.payload;
      state.deviceProfiles = state.deviceProfiles.filter((profile) => profile.id !== deletedId);
    },
  },
  extraReducers: {
    [fetchDeviceProfiles.fulfilled.type]: (state, action: PayloadAction<IDeviceProfile []>) => {
      state.isLoading = false;
      state.error = '';
      state.deviceProfiles = action.payload.sort((a, b) => smartSort(a.name, b.name));
    },
    [fetchDeviceProfiles.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDeviceProfiles.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { removeDeviceProfile } = deviceProfilesSlice.actions;
export default deviceProfilesSlice.reducer;
